export const CHECKOUT_URL = 'https://pilates-pronto.impultienda.ar/checkout'

export const CTA_LABEL = 'OTTIENI PILATES REFORMER PRONTO'

export const OFFER_ANCHOR = '#offerta'
